import React, { useEffect, useState } from "react";
// mui
import { Grid2 } from "@mui/material";
//styling
import styles from "./DevTools.module.scss";
// local import
import SiteHeaderCard from "../../Components/HeaderComponent/Header";
import DevToolsGrid from "../../Components/DevToolsComponents/DevToolsGrid";
import { useSelector } from "react-redux";
import { Actions } from "../../../../../../redux/constants/actionTypes";
import { getStore } from "../../../../../../Utils/storeUtils";
import {
  adminApi,
  lastSegmentPath,
  STAGING,
} from "../../../../../../Utils/roconConstants";
import FormPopup from "../../../../../../GlobalComponents/FormPopup/FormPopup";
import {
  siteDetails,
  devToolsConst,
  getStagingEnv,
  staging,
} from "../../../../../../Utils/sitePages";
import SftpPopup from "./Components/SftpPopup";
import { useLocation, useParams } from "react-router-dom";
import DevToolsTable from "./Components/DevToolsTable";
import EbsSshDetails from "./Components/EbsSshDetails";
import EbsSftpDetails from "./Components/EbsSftpDetails";
import { ConnectInstance } from "../../../../../../GlobalComponents/ConnectInstance/ConnectInstance";
import TabsComponent from "../../../../../../GlobalComponents/TabsComponent/TabsComponent";
import PageLoading from "../../../../../../GlobalComponents/PageLoading/PageLoading";
const tabs = [
  { title: "Php My Admin", value: "phpMyAdmin" },
  { title: "SSH Setup", value: "sshSetup" },
  { title: "SFTP Setup", value: "sftpSetup" },
];

export default function DevTools() {
  const [sftpPopup, setSftpPopup] = useState(false);
  const [loading, setLoading] = useState(false);
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [cardStatus, setCardStatus] = useState({
    title: "Php My Admin",
    value: "phpMyAdmin",
  });
  const [popup, setPopup] = useState({
    popupState: false,
    popupType: "",
    popupTitle: "",
    popupSubtitle: "",
    popupSubtitle1: "",
    popupButton: false,
    popupCancel: false,
    popupButtonTitle: "",
    popupCancelTitle: "",
    popupButtonFunction: () => {},
    popupCancelFunction: () => {},
  });

  let sites = useSelector((state) => state?.sitesInfo?.selectedSite);
  const isDedicated = sites?.dedicatedInstanceDetails;
  let organizationsInfo = useSelector(
    (state) => state.organizationsInfo.selectedOrg
  );
  const siteData = siteDetails(sites);
  const isStaging = staging(sites);

  const location = useLocation();
  const lastSegment = lastSegmentPath(location);

  const params = useParams();
  const orgId = params.orgId;
  const siteId = params.siteId;

  let livedom = siteData?.domain.find((item) => item.primary === "Y")?.name;

  const selectedDomain = useSelector((state) => state.sitesInfo.selectedDomain);

  const plansInfo = useSelector((state) => state.plansInfo?.specificPlan);
  const loadingState = plansInfo?.specificPlans;
  const dedicatedHosting = plansInfo?.isDedicated === true;

  useEffect(() => {
    getStore().dispatch({
      type: Actions.API_GET_SELECTED_SITE_DETAILS,
      data: { siteId: siteId },
      meta: {
        onSuccess: (response) => {
          let sitename = response?.domainName;
          if (response?.ebsSite === true) {
            // v2: one SFTP login per site, looked up on the NLB (the v1 user list is Secrets Manager)
            getStore().dispatch({
              type: Actions.API_EBS_SFTP_DETAILS,
              data: { siteId: siteId },
            });
          } else if (plansInfo && !dedicatedHosting) {
            getStore().dispatch({
              type: Actions.API_SFTP_USER_LIST,
              data: {
                siteId: siteId,
                domainName:
                  selectedDomain?.environment === "STAGING"
                    ? selectedDomain.domainName
                    : sitename,
              },
            });
          }
          const selectedEnvData = response.stagingDomainsList.find(
            (list) =>
              list?.environment ===
              (selectedDomain?.environment === "STAGING" ? "STAGING" : "LIVE")
          );
          getStore().dispatch({
            type: Actions.SET_SELECTED_DOMAIN,
            data: selectedEnvData,
          });
          if (dedicatedHosting) {
            getStore().dispatch({
              type: Actions.API_GET_PHP_CREDS,
              data: { siteName: sitename },
            });
          }
        },
        onError: () => {},
      },
    });
    getStore().dispatch({
      type: Actions.SET_SITE_DETAILS,
      data: {
        orgId: orgId,
        siteId: siteId,
        sitePage: lastSegment,
      },
    });
  }, [selectedDomain?.environment, siteId, plansInfo]);

  const phpCreds = sites?.phpCreds;

  const wp = siteData?.staging?.find((item) => ({
    wpDebug: item?.wpDebug,
    wpCache: item?.wpCache,
  }));

  const ActivatePopup = (type) => {
    if (type === "waf") {
      setPopup({
        popupState: true,
        popupType: devToolsConst.POPUP_TYPE_INFO,
        popupTitle: devToolsConst.POPUP_TITLE,
        popupSubtitle: devToolsConst.POPUP_SUB_TITLE,
        popupCancel: true,
        popupButton: true,
        popupButtonTitle: devToolsConst.YES,
        popupCancelTitle: devToolsConst.NO,
        popupCancelFunction: () => {
          setPopup({ popupState: false });
        },
        popupButtonFunction: () => {
          wafAPI();
        },
      });
    } else if (type === "wpdebug") {
      setPopup({
        popupState: true,
        popupType: devToolsConst.POPUP_TYPE_INFO,
        popupTitle: devToolsConst.POPUP_TITLE,
        popupSubtitle: devToolsConst.POPUP_SUB_TITLE,
        popupCancel: true,
        popupButton: true,
        popupButtonTitle: devToolsConst.YES,
        popupCancelTitle: devToolsConst.NO,
        popupCancelFunction: () => {
          setPopup({ popupState: false });
        },
        popupButtonFunction: () => {
          wpDebugAPI();
        },
      });
    } else if (type === "wpcache") {
      setPopup({
        popupState: true,
        popupType: devToolsConst.POPUP_TYPE_INFO,
        popupTitle: devToolsConst.POPUP_TITLE,
        popupSubtitle: devToolsConst.POPUP_SUB_TITLE,
        popupCancel: true,
        popupButton: true,
        popupButtonTitle: devToolsConst.YES,
        popupCancelTitle: devToolsConst.NO,
        popupCancelFunction: () => {
          setPopup({ popupState: false });
        },
        popupButtonFunction: () => {
          wpCacheAPI();
        },
      });
    } else if (type === "loading") {
      setPopup({
        popupState: true,
        popupType: "loading",
        popupTitle: "Please Wait",
        popupSubtitle: "Changes are being updated",
        popupCancel: false,
        popupButton: false,
      });
    } else if (type === "loading-del") {
      setPopup({
        popupState: true,
        popupType: "loading",
        popupTitle: "Please Wait",
        popupSubtitle: "Deleting your SFTP user...",
        popupCancel: false,
        popupButton: false,
      });
    } else if (type === "success") {
      setPopup({
        popupState: true,
        popupType: "success",
        popupTitle: "Hurray, it's done!",
        popupSubtitle: "Changes updated successfully.",
        popupButton: true,
        popupCancel: false,
        popupButtonTitle: "OK",
        popupButtonFunction: () => {
          setPopup({ popupState: false });
        },
      });
    } else if (type === "success-sftp") {
      setPopup({
        popupState: true,
        popupType: "success",
        popupTitle: "SFTP User Created",
        popupSubtitle: "Your SFTP user has been created successfully.",
        popupButton: true,
        popupCancel: false,
        popupButtonTitle: devToolsConst.OK,
        popupButtonFunction: () => {
          getStore().dispatch({
            type: Actions.API_SFTP_USER_LIST,
            data: {
              siteId: siteData?.siteId,
              domainName:
                selectedDomain?.environment === "STAGING"
                  ? selectedDomain.domainName
                  : siteData?.siteName,
            },
          });
          setPopup({ popupState: false });
        },
      });
    } else if (type === "success-del") {
      setPopup({
        popupState: true,
        popupType: "success",
        popupTitle: "SFTP User Deleted",
        popupSubtitle: "The user has been successfully deleted.",
        popupButton: true,
        popupCancel: false,
        popupButtonTitle: "OK",
        popupButtonFunction: () => {
          setPopup({ popupState: false });
        },
      });
    } else if (type === "error") {
      setPopup({
        popupState: true,
        popupType: "error",
        popupTitle: "Oops! Something went wrong",
        popupSubtitle: "An error occurred. Please try again.",
        popupCancel: false,
        popupButton: true,
        popupButtonTitle: "OK",
        popupButtonFunction: () => {
          setPopup({ popupState: false });
        },
      });
    } else if (type === "waf_warning") {
      setPopup({
        popupState: true,
        popupType: "warning",
        popupTitle: "Waf is being updated, we will notify you once it's done",
        popupCancel: false,
        popupButton: true,
        popupButtonTitle: "OK",
        popupButtonFunction: () => {
          setPopup({ popupState: false });
        },
      });
    } else if (type === "download_success") {
      setPopup({
        popupState: true,
        popupType: "success",
        popupTitle: "Hurray, it's done!",
        popupSubtitle: "Your key has been downloaded successfully.",
        popupButton: true,
        popupCancel: false,
        popupButtonTitle: "OK",
        popupButtonFunction: () => {
          setPopup({ popupState: false });
        },
      });
    } else if (type === devToolsConst.NONE) {
      setPopup({ popupState: false });
    }
  };

  const apis = () => {
    getStore().dispatch({
      type: Actions.API_GET_SELECTED_SITE_DETAILS,
      data: { siteId: siteId },
      meta: {
        onSuccess: (data) => {
          if (data?.ebsSite === true) {
            getStore().dispatch({
              type: Actions.API_EBS_SFTP_DETAILS,
              data: { siteId: siteId },
            });
          } else if (!dedicatedHosting && plansInfo) {
            getStore().dispatch({
              type: Actions.API_SFTP_USER_LIST,
              data: {
                siteId: siteData?.siteId,
                domainName:
                  selectedDomain?.environment === "STAGING"
                    ? selectedDomain.domainName
                    : siteData?.siteName,
              },
            });
          }
          const selectedEnvData = data.stagingDomainsList.find(
            (list) =>
              list?.environment ===
              (selectedDomain?.environment === "STAGING" ? "STAGING" : "LIVE")
          );
          getStore().dispatch({
            type: Actions.SET_SELECTED_DOMAIN,
            data: selectedEnvData,
          });
        },
        onError: () => {},
      },
    });
    setLoading(false);
    ActivatePopup("success");
  };

  const wafAPI = () => {
    setLoading(true);
    getStore().dispatch({
      type: Actions.API_WAF,
      data: {
        siteId: siteData.siteId,
        status: !siteData.wafStatus,
      },
      meta: {
        onSuccess: () => {
          apis();
        },
        onError: () => {
          setLoading(false);
          setPopup(false);
        },
      },
    });
  };

  const wpDebugAPI = () => {
    setLoading(true);
    getStore().dispatch({
      type: Actions.API_WP_DEBUG,
      devtools: {
        siteId: siteId,
        ebsSite: sites?.ebsSite === true,
        action: !selectedDomain?.wpDebug,
        stagingDomainName:
          selectedDomain?.environment === "STAGING"
            ? selectedDomain.domainName
            : siteData?.domainName,
      },
      meta: {
        onSuccess: () => {
          apis();
        },
        onError: () => {
          setLoading(false);
          ActivatePopup("error");
        },
      },
    });
  };

  const wpCacheAPI = () => {
    setLoading(true);
    getStore().dispatch({
      type: Actions.API_WP_CACHE,
      devtools: {
        siteId: siteId,
        ebsSite: sites?.ebsSite === true,
        action: !selectedDomain?.wpCache,
        stagingDomainName:
          selectedDomain?.environment === "STAGING"
            ? selectedDomain.domainName
            : siteData?.siteName,
      },
      meta: {
        onSuccess: () => {
          apis();
        },
        onError: () => {
          setLoading(false);
          ActivatePopup("error");
        },
      },
    });
  };

  const cacheFunc = () => {
    ActivatePopup("loading");
    getStore().dispatch({
      type: Actions.API_CACHE_INVALIDATION,
      data: {
        siteId: siteId,
        ebsSite: sites?.ebsSite === true,
        siteName:
          selectedDomain?.environment === "STAGING"
            ? selectedDomain.domainName
            : siteData?.siteName,
      },
      meta: {
        onSuccess: () => {
          ActivatePopup("success");
        },
        onError: () => {
          ActivatePopup("error");
        },
      },
    });
  };

  // const openSSH = () => {
  //   window.open(
  //     `/account/${orgId}/${siteId}/ssh?domainName=${selectedDomain.domainName}`,
  //     "_blank"
  //   );
  // };

  const rows = siteData?.sftp?.map((sftpUser) => ({
    host: devToolsConst.HOST,
    name: sftpUser,
    port: 22,
    delete: () => apiDelSFTP(sftpUser),
  }));

  const apiDelSFTP = (sftpUser) => {
    ActivatePopup("loading-del");
    getStore().dispatch({
      type: Actions.API_DELETE_SFTP_USER,
      data: {
        domainName:
          selectedDomain?.environment === "STAGING"
            ? selectedDomain.domainName
            : siteData?.domainName,
        siteId: siteId,
        secretNameSuffix: sftpUser,
      },
      meta: {
        onSuccess: () => {
          apis();
        },
        onError: () => {
          ActivatePopup("error");
        },
      },
    });
  };

  const handleDownloadKey = (siteName) => {
    setDownloadLoading(true);
    getStore().dispatch({
      type: Actions.API_DOWNLOAD_INSTANCE_KEY,
      data: {
        instanceName: siteName,
      },
      meta: {
        onSuccess: () => {
          setDownloadLoading(false);
          ActivatePopup("download_success");
        },
        onError: () => {
          setDownloadLoading(false);
          ActivatePopup("error");
        },
      },
    });
  };

  return (
    <>
      <Grid2 className={styles.Container}>
        <Grid2 className={styles.header}>{devToolsConst.HEADER}</Grid2>
        {loadingState?.length === 0 ? (
          <PageLoading />
        ) : (
          <>
            {siteData?.siteName && (
              <SiteHeaderCard
                name={
                  selectedDomain?.environment === "STAGING"
                    ? selectedDomain.domainName
                    : siteData.siteName
                }
                domain={
                  livedom?.length > 0 &&
                  (selectedDomain?.environment !== "STAGING" || isDedicated)
                    ? livedom
                    : (selectedDomain?.environment === "STAGING"
                        ? selectedDomain.domainName
                        : siteData.siteName) +
                      "." +
                      process.env.REACT_APP_TEMP_DOMAIN
                }
                development={isStaging}
                production={getStagingEnv(siteData.staging, STAGING.LIVE)}
                phpClick={() => adminApi("php")}
                wpClick={() =>
                  adminApi(
                    "wp",
                    selectedDomain?.environment === "STAGING"
                      ? selectedDomain.domainName
                      : siteData.siteName,
                    selectedDomain?.environment === "STAGING"
                      ? selectedDomain.domainName
                      : livedom?.length > 0
                        ? livedom
                        : null,
                    selectedDomain?.environment === "STAGING" ? true : false,
                  )
                }
                domainClick={() =>
                  adminApi(
                    "domain",
                    selectedDomain?.environment === "STAGING"
                      ? selectedDomain.domainName
                      : siteData.siteName,
                    selectedDomain?.environment === "STAGING"
                      ? selectedDomain.domainName
                      : livedom?.length > 0
                        ? livedom
                        : null,
                    selectedDomain?.environment === "STAGING" ? true : false,
                  )
                }
                siteId={siteId}
                orgId={orgId}
                image={siteData.imagePath ? siteData.imagePath : null}
                orgInfo={organizationsInfo}
                addOnWaf={siteData.wafStatus}
                addOnPerformanceSite={siteData.performanceSite}
                dedicatedHosting={dedicatedHosting}
              />
            )}

            <DevToolsGrid
              ebsSite={sites?.ebsSite === true}
              waf={siteData?.wafStatus}
              wafUpdating={siteData?.wafUpdateStatus !== "Updated"}
              cache={
                selectedDomain?.environment === "STAGING" ||
                selectedDomain?.environment === "LIVE"
                  ? selectedDomain?.wpCache
                  : wp?.wpCache
              }
              debug={
                selectedDomain?.environment === "STAGING" ||
                selectedDomain?.environment === "LIVE"
                  ? selectedDomain?.wpDebug
                  : wp?.wpDebug
              }
              cdnFunc={() => cacheFunc()}
              // openSsh={() => openSSH()}
              wafClick={() => {
                if (siteData?.wafUpdateStatus !== "Updated") {
                  ActivatePopup("waf_warning");
                } else ActivatePopup("waf");
              }}
              cacheClick={() => {
                ActivatePopup("wpcache");
              }}
              debugClick={() => {
                ActivatePopup("wpdebug");
              }}
              dedicatedHosting={dedicatedHosting}
            />

            {dedicatedHosting ? (
              <Grid2>
                <TabsComponent
                  selectedTab={cardStatus}
                  setSelectedTab={setCardStatus}
                  tabs={tabs}
                />
                {cardStatus.value === "phpMyAdmin" && (
                  <ConnectInstance
                    header="Php My Admin"
                    helpLink="https://docs.roconpaas.io/home/access-your-sites-php-db-using-ssh-key/"
                    buttonText="Download SSH Key"
                    onClick={() => handleDownloadKey(siteData?.siteName)}
                    buttonLoading={downloadLoading}
                    details={[
                      {
                        title: "1. Download Your Key",
                        subTitle:
                          "(Note: This instance uses the default SSH key, if already downloaded proceed with next step)",
                        showButton: true,
                      },
                      {
                        title: "2. Set permission to key file",
                        subTitle:
                          "Use the following command in your terminal to set permission:",
                        text: `chmod 600 [PATH_TO_KEY]`,
                        noteText:
                          "(Note: Replace [PATH_TO_KEY] with actual key path)",
                      },
                      {
                        title: "3. Connect to Instance",
                        subTitle: "Use the following command in your terminal:",
                        text: `ssh -f -N -L 8888:127.0.0.1:80 -i [PATH_TO_KEY] ${isDedicated?.userName}@${isDedicated?.sshIp}`,
                        noteText:
                          "(Note: Replace [PATH_TO_KEY] with actual key path)",
                      },
                      {
                        title: "4. Access PhpMyAdmin",
                        subTitle: "Use the following link",
                        link: "http://localhost:8888/phpmyadmin",
                        linkUrl: "http://localhost:8888/phpmyadmin",
                      },
                    ]}
                    inputs={[
                      {
                        header: "5. Phpmyadmin credentials",
                        subHeader:
                          "Use the following details to access phpmyadmin",
                      },
                      {
                        title: "User Name",
                        placeHolder: `${phpCreds?.dbUser}`,
                      },
                      {
                        title: "Password",
                        placeHolder: `${phpCreds?.dbPassword}`,
                      },
                    ]}
                  />
                )}
                {cardStatus.value === "sshSetup" && (
                  <ConnectInstance
                    header="CONNECT TO YOUR INSTANCE - SSH"
                    helpLink="https://docs.roconpaas.io/home/connect-to-your-site-using-ssh/"
                    buttonText="Download SSH Key"
                    onClick={() => handleDownloadKey(siteData?.siteName)}
                    buttonLoading={downloadLoading}
                    details={[
                      {
                        title: "1. Download Your Key",
                        subTitle:
                          "This instance uses the default SSH key for the Oregon (us-west-2)",
                        showButton: true,
                      },
                      {
                        title: "2. Set permission to key file",
                        subTitle:
                          "Use the following command in your terminal to set permission:",
                        text: `chmod 600 [PATH_TO_KEY]`,
                        noteText:
                          "(Note: Replace [PATH_TO_KEY] with actual key path)",
                      },
                      {
                        title: "3. Connect to Instance",
                        subTitle: "Use the following command in your terminal:",
                        text: `ssh -i [PATH_TO_KEY] ${isDedicated?.userName}@${isDedicated?.sshIp}`,
                        noteText:
                          "(Note: Replace [PATH_TO_KEY] with actual key path)",
                      },
                    ]}
                    inputs={[
                      {
                        header: "4. Full Connection Details",
                      },
                      {
                        title: "Public IPv4 address",
                        placeHolder: isDedicated?.sshIp,
                        value: isDedicated?.sshIp,
                      },
                      {
                        title: "Username",
                        placeHolder: isDedicated?.userName,
                        value: isDedicated?.userName,
                      },
                    ]}
                  />
                )}
                {cardStatus.value === "sftpSetup" && (
                  <ConnectInstance
                    header="CONNECT TO YOUR INSTANCE - SFTP"
                    helpLink="https://docs.roconpaas.io/home/access-your-site-using-sftp-with-ssh-key/"
                    buttonText="Download SFTP Key"
                    onClick={() => handleDownloadKey(siteData?.siteName)}
                    buttonLoading={downloadLoading}
                    details={[
                      {
                        title: "1. Download Your Key",
                        subTitle:
                          "This instance uses the default SSH key for the Oregon (us-west-2)",
                        showButton: true,
                      },
                      {
                        title: "2. Set permission to key file",
                        subTitle:
                          "Use the following command in your terminal to set permission:",
                        text: `chmod 600 [PATH_TO_KEY]`,
                        noteText:
                          "(Note: Replace [PATH_TO_KEY] with actual key path)",
                      },
                      {
                        title: "3. Access using filezilla",
                        subTitle:
                          "Please refer to the following documentation for instructions on setting up SFTP.",
                        link: "Learn more",
                        linkUrl:
                          "https://docs.roconpaas.io/home/access-your-site-using-sftp-with-ssh-key/",
                      },
                    ]}
                    inputs={[
                      {
                        header: "4. Full Connection Details",
                      },
                      {
                        title: "Public IPv4 address",
                        placeHolder: isDedicated?.sshIp,
                        value: isDedicated?.sshIp,
                      },
                      {
                        title: "Username",
                        placeHolder: isDedicated?.userName,
                        value: isDedicated?.userName,
                      },
                    ]}
                  />
                )}
              </Grid2>
            ) : (
              <>
                {/* EBS (v2) sites: SSH login chosen at creation (host/user only, no password) */}
                {sites?.ebsSite === true && (
                  <EbsSshDetails
                    sshEnabled={sites?.sshEnabled === true}
                    sshHost={sites?.sshHost}
                    sshUsername={sites?.sshUsername || siteData?.domainName}
                  />
                )}
                {sites?.ebsSite === true ? (
                  <EbsSftpDetails sftp={sites?.ebsSftp} />
                ) : (
                  <DevToolsTable
                    rows={rows}
                    sftpClick={() => setSftpPopup(true)}
                    sites={sites}
                  />
                )}
              </>
            )}
          </>
        )}
      </Grid2>

      <SftpPopup
        siteData={siteData}
        sftpPopup={sftpPopup}
        setSftpPopup={setSftpPopup}
        rows={rows}
        selectedDomain={selectedDomain}
        successSFTP={() => ActivatePopup("success-sftp")}
        errorSFTP={() => ActivatePopup("error")}
      />
      <FormPopup
        trigger={popup.popupState}
        setTrigger={setPopup}
        type={popup.popupType}
        title={popup.popupTitle}
        subtitle={popup.popupSubtitle}
        button={popup.popupButton}
        cancel={popup.popupCancel}
        buttonTitle={popup.popupButtonTitle}
        buttonFunction={popup.popupButtonFunction}
        loading={loading}
        cancelTitle={popup.popupCancelTitle}
        cancelFunction={popup.popupCancelFunction}
      />
    </>
  );
}
